<template>
    <div class="content">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
            <Row>
                <!-- 当Form中只有一个input时回车会自动提交表单，这是浏览器的默认行为。 -->
                <Col span="4">
                    <FormItem label="渠道搜索" class="mb-10" style="95%">
                       <Input v-model="listQuery.name"  placeholder="请输入渠道名称" @keydown.native.enter.prevent ="handleEnter" />
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="所属部门" class="mb-10" style="95%">
                        <Select  v-model="listQuery.department_id"   placeholder="请选择所属部门"    >
                            <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="状态" class="mb-10" style="95%">
                        <Select v-model="listQuery.status"    placeholder="请选择状态">
                            <Option  value="1" >显示</Option>
                            <Option  value="2" >不显示</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="开放门店" class="mb-10" style="95%">
                        <Select v-model="listQuery.store_id"   placeholder="请选择门店">
                            <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem :label-width="0" class="mb-10" style="margin-left:10px">
                        <Button   type="primary" icon="ios-search" @click="searchList">查询</Button>
                        <Button  type="primary" icon="ios-search" @click="emptyFilter">清空筛选</Button>
                        <Button   icon="ios-add" type="primary" @click="addChannel('isAdd')">添加</Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div class="table_wrap">
            <div style="width:100%">
                <Table   stripe border ref="table"
                    :height="tableHeight"
                    :loading="tabLoading"  
                    :columns="tabColumns" 
                    :data="tabData"
                ></Table>
                <div style="margin-top:20px;display:flex;justify-content:flex-end">
                    <Page show-total show-elevator show-sizer  :page-size-opts="pageSizeOpts" :page-size="50"
                        :total="total"  :current="listQuery.page"
                        :transfer="true"
                        @on-change="changePage" 
                        @on-page-size-change="changeLimit"/>
                </div>
            </div>
        </div>

         <!-- 添加|编辑渠道对话框 -->
        <Modal
            v-model="showAddChannel"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>{{isTitle}}</span>
                </p>
                <Form  ref="addChannelForm" :model="addChannelForm" :rules="addChannelFormRule" :label-width="80" >
                    <FormItem label="名称" prop="name">
                        <Input v-model="addChannelForm.name" style="width:90%"   placeholder="请输入渠道名称"></Input>
                    </FormItem>
                    <FormItem label="所属部门" prop="department_id">
                        <Select v-model="addChannelForm.department_id"   style="width:90%" placeholder="请选择部门" @on-change="changeDepartment">
                            <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label="状态" prop="status">
                        <RadioGroup v-model="addChannelForm.status"  style="width:90%" >
                            <Radio  label='1'>显示</Radio>
                            <Radio  label='2'>不显示</Radio>
                        </RadioGroup>
                    </FormItem>

                    <FormItem label="标签" prop="tag_id">
                        <CheckboxGroup v-model="addChannelForm.tag_id" >
                            <Checkbox  v-for="item in channelTagList" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
                        </CheckboxGroup>
                    </FormItem>

                    <FormItem label="开放门店" required>
                        <Input v-model="openStoreStr" readonly style="width:90%"   placeholder=""></Input>
                    </FormItem>

                    <FormItem label="备注"  >
                        <Input style="width:90%"  type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                        v-model="addChannelForm.remark"  
                        placeholder="请输入100字内的备注"
                        :maxlength="100"
                        ></Input>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addChannelForm',isTitle)">确定</Button>
                    <Button  size="large"  @click="handleReset('addChannelForm')">取消</Button>
                </div>
        </Modal>
        <!-- 下载推广二维码对话框=-->
        <Modal
            v-model="showQrCode"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>该二维码允许开放的门店</span>
                </p>
                <Form  ref="editQrCodeForm" :model="editQrCodeForm" :rules="editQrCodeFormRule" :label-width="80" >
                    <FormItem label="开放门店" prop="store_id">
                        <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                            <Checkbox
                                :indeterminate="indeterminate"
                                :value="checkAll"
                                @click.prevent.native="handleCheckAll">全选</Checkbox>
                        </div>
                        <!-- <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                            <Checkbox label="香蕉"></Checkbox>
                            <Checkbox label="苹果"></Checkbox>
                            <Checkbox label="西瓜"></Checkbox>
                        </CheckboxGroup> -->
                        <CheckboxGroup v-model="editQrCodeForm.store_id" @on-change="checkAllGroupChange">
                            <Checkbox  v-for="item in qrCodeOpenStoreList" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                </Form>
                <div slot="footer">
                    <Button type="primary" size="large"  @click="downloadQrCode">保存并下载二维码</Button>
                    <Button type="primary" size="large"  @click="handleSubmit('editQrCodeForm',isTitle)">确定</Button>
                    <Button  size="large"  @click="handleReset('editQrCodeForm')">取消</Button>
                    
                </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'channelManagement',
    data(){
        return{
            storeList:[],
            departmentList:[],
            channelTagList:[],
            showAddChannel:false,  

            showQrCode:false,
            qrCodeOpenStoreList:[],
            indeterminate: false,
            checkAll: false,
            checkAllGroup: [],

            tabLoading:false,
            tableHeight:650,
            tabData:[],
            tabColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        align:'center',
                        width:100
                    },
                    {
                        title: '渠道名称',
                        key: 'name',
                        align:'center',
                        width:180
                    },
                    {
                        title: '所属部门',
                        key: 'department_name',
                        align:'center',
                        width:180
                    },
                    {
                        title: '标签',
                        key: 'channel_tags_name',
                        align:'center',
                    },
                    {
                        title: '状态',
                        key: 'status_text',
                        align:'center',
                        width:100
                    },
                    {
                        title: '开放门店',
                        key: 'store',
                        align:'center'
                    },
                    {
                        title: '备注',
                        key: 'remark',
                        align:'center',
                    },
                    {
                        title: '操作',
                        width: 260,
                        align: 'center',
                        render: (h, params) => {
                            // console.log('操作params',params)
                            switch(params.row.status){
                                case 1:
                                    return h('div', [
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                   this.apiShowChannel(params.row)
                                                }
                                            }
                                        }, '不显示'),
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.addChannel(params.row.id)
                                                }
                                            }
                                        }, '修改'),
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: (e) => {
                                                    // 跳转二维码
                                                    // this.apiQrCode(params.row.id,params.row.department_id,params.row.name,params.row.department_name);
                                                    
                                                    // window.open(api.getRecommendQrCode+'?channel_id='+params.row.id+'&department_id='+params.row.department_id+'&recommend_token=8541701242fe1c51rwwfs412rew1935e2c6e6c')
                                                    this.apiQrCodeOpenStore(params.row.id,params.row.department_id);
                                                }
                                            }
                                        }, '推广二维码')
                                    ]);
                                break;
                                case 2:
                                    return h('div', [
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                   this.apiShowChannel(params.row)
                                                }
                                            }
                                        }, '显示'),
                                        h('Button', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.addChannel(params.row.id)
                                                }
                                            }
                                        }, '修改'),
                                        h('Button', {
                                            props: {
                                                type: 'error',
                                                size: 'small'
                                            },
                                            style: {
                                                marginRight: '5px'
                                            },
                                            on: {
                                                click: () => {
                                                    this.apiDeleteChannel(params.row)
                                                }
                                            }
                                        }, '删除'),
                                        // h('Button', {
                                        //     props: {
                                        //         type: 'primary',
                                        //         size: 'small'
                                        //     },
                                        //     style: {
                                        //         marginRight: '5px'
                                        //     },
                                        //     on: {
                                        //         click: () => {
                                        //             // 跳转二维码
                                        //             //this.apiQrCode(params.row.id,params.row.department_id,params.row.name,params.row.department_name);
                                        //             window.open(api.getRecommendQrCode+'?channel_id='+params.row.id+'&department_id='+params.row.department_id+'&recommend_token=8541701242fe1c51rwwfs412rew1935e2c6e6c')
                                        //         }
                                        //     }
                                        // }, '下载二维码')
                                    ]);
                                break;
                            }
                        }
                    }
                ],
           
            // 列表查询参数
            listQuery:{
                page:1,
                limit:50,
                department_id:'',
                store_id:'',
                status:'',
                name:''
            },
            total:0,
            pageSizeOpts:[50,60,70,80,90,100],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            stylesModal:{
                height: '500px',
                overflow: 'auto',
                // position: 'static'
            },

            isTitle:'添加渠道',
            isEditorChannelId:'',
            addChannelForm:{
                name:'',
                department_id:'',
                status:'',
                tag_id:[],
                remark:''
            },
            openStoreStr:'',
            editQrCodeForm:{
                channel_id:'',
                department_id:'',
                store_id:[]
            },
            editQrCodeFormRule:{
                store_id: [
                    { required: true, type: 'array', min: 1, message: '请选择开放门店', trigger: 'change' },
                ],
            },
            addChannelFormRule:{
                name: [
                    { required: true, message: '请输入渠道名称', trigger: 'blur' }
                ],
                department_id: [
                    { required: true, message: '请选择部门', trigger: 'change',type:'number'}
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ],
                tag_id: [
                    { required: true, type: 'array', min: 1, message: '请选择标签', trigger: 'change' },
                ],
                // remark:[
                //     { required: true, message: '请输入', trigger: 'blur' },
                //     { type: 'string', max: 100, message: '备注不能大于100字', trigger: 'blur' }
                // ],
            }
        }
    },
    created(){
        this.apiStoreAll()
        this.apiChannelTagAll()
        this.apiDepartmentAll()
        this.getList()
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220
    },
    methods:{
        handleEnter(){
            return false;
        },
        // 全选
        handleCheckAll () {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                var checkStoreArr=[];
                this.qrCodeOpenStoreList.forEach(item => {
                    checkStoreArr.push(item.id);
                });
                 this.editQrCodeForm.store_id=checkStoreArr;
                // this.editQrCodeForm.store_id = ['香蕉', '苹果', '西瓜'];
            } else {
                this.editQrCodeForm.store_id = [];
            }
        },
        // 选中一项
        checkAllGroupChange (data) {
            if (data.length === this.qrCodeOpenStoreList.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        //获取填写客资二维码
        apiQrCode(channel_id,department_id,channel_name,department_name){
            serve.fetchGet(api.getRecommendQrCode,{
                channel_id:channel_id,
                department_id:department_id,
                recommend_token:'8541701242fe1c51rwwfs412rew1935e2c6e6c'
            }).then(data => {
                console.log(data);
                // if(data.errcode==1){
                //     let alink = document.createElement('a');
                //     alink.target="_blank";
                //     alink.rel="noopener noreferrer";
                //     alink.download = channel_name+department_name+'二维码.png';
                //     console.log('msg',data.msg)
                //     alink.href = 'http://'+data.msg;
                //     alink.style.display = 'none';
                //     document.body.appendChild(alink);
                //     alink.click();
                //     document.body.removeChild(alink);

                //     // imgsrc, name
                //     // var image = new Image();
                //     // // 解决跨域 Canvas 污染问题
                //     // image.setAttribute("crossOrigin", "anonymous");
                //     // image.onload = function() {
                //     //     var canvas = document.createElement("canvas");
                //     //     canvas.width = image.width;
                //     //     canvas.height = image.height;
                //     //     var context = canvas.getContext("2d");
                //     //     context.drawImage(image, 0, 0, image.width, image.height);
                //     //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                //     //     var a = document.createElement("a"); // 生成一个a元素
                //     //     var event = new MouseEvent("click"); // 创建一个单击事件
                //     //     a.download = name || "二维码"; // 设置图片名称
                //     //     a.href = url; // 将生成的URL设置为a.href属性
                //     //     a.dispatchEvent(event); // 触发a的单击事件
                //     // };
                //     // image.src ='http://'+data.msg;
                // }else{
                //     this.$Message.error('下载二维码出错！');
                // }
               
            }).catch((error)=>{
                this.$Message.error('下载二维码出错！');
            })
        },
        //获取渠道推广二维码开放的门店
        apiQrCodeOpenStore(channel_id,department_id){
            serve.fetchGet(api.getChannelQrCodeStore+'/'+channel_id,{}).then(data => {
                console.log('获取渠道推广二维码开放的门店',data)
                var checkStoreArr=[];
                data.forEach(item => {
                    if(item.is_check==1){
                        checkStoreArr.push(item.id)
                    }
                });
                if(data.length==checkStoreArr.length){
                    this.indeterminate = false;
                    this.checkAll = true;
                }else if (checkStoreArr.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
                this.editQrCodeForm.channel_id=channel_id;
                this.editQrCodeForm.department_id=department_id;
                this.editQrCodeForm.store_id=checkStoreArr;
                this.qrCodeOpenStoreList = data;
                this.showQrCode=true;
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
            
        },
        //允许该二维码开放的门店
        apiQrCodeAddOpenStore(){
            serve.fetchPost(api.addChannelQrCodeStore,this.editQrCodeForm).then(res => {
                console.log('允许该二维码开放的门店',res)
                if(res[0]){
                    this.$Message.success('设置成功');
                    this.showQrCode=false
                }else{
                    this.$Message.error('设置失败');
                }
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 门店
        apiStoreAll(){
            serve.fetchGet(api.crmChannelStore,{}).then(data => {
                this.storeList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 部门
        apiDepartmentAll(){
            serve.fetchGet(api.crmChannelDepartment,{}).then(data => {
                this.departmentList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //标签
        apiChannelTagAll(){
            serve.fetchGet(api.crmChannelTagAll,{}).then(res => {
                this.channelTagList=res.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //开放门店
        apiOpenStore(param){
            if(param!=undefined){
                serve.fetchGet(api.department+'/'+param,{}).then(res => {
                    if(res.data.store.length){
                        this.openStoreStr = res.data.store.join(',')
                    }
                }).catch((error)=>{
                    this.$Message.error(error.response.data.message);
                })
            }
        },
        // 渠道详情
        apiChannelDetails(id){
            serve.fetchGet(api.crmChannel+'/'+id,{}).then(res => {
                this.addChannelForm.name=res.data.name
                this.addChannelForm.department_id=res.data.department_id
                this.addChannelForm.status=res.data.status.toString()
                this.addChannelForm.tag_id=res.data.channel_tags_id
                this.openStoreStr=res.data.store.join(',')
                this.addChannelForm.remark=res.data.remark
                this.showAddChannel=true
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 显示or不显示
        apiShowChannel(param){
            let params={
                name:param.name,
                department_id:param.department_id,
                status:param.status==1?2:1,
                tag_id:param.channel_tags_id,
                remark:param.remark
            }
            serve.fetchPut(api.crmChannel+"/"+param.id,params).then(res => {
                this.$Message.success('修改成功');
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 删除渠道
        apiDeleteChannel(param){
            serve.fetchDelete(api.crmChannel+"/"+param.id,{}).then(res => {
                this.$Message.success('删除成功');
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 修改渠道
        apiEditorChannel(){
            serve.fetchPut(api.crmChannel+"/"+this.isEditorChannelId,this.addChannelForm).then(res => {
                this.showAddChannel=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //  添加渠道
        apiAddChannel(){
            serve.fetchPost(api.crmChannel,this.addChannelForm).then(res => {
                this.showAddChannel=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 获取列表
        getList(){
            this.tabLoading=true
            serve.fetchGet(api.crmChannel,this.listQuery).then(res => {
                var data=res.data;
                if(data.length){
                    for(var i=0;i<data.length;i++){
                        if(data[i].channel_tags_name.length){
                            data[i].channel_tags_name=data[i].channel_tags_name.join(' ')
                        }else{
                            data[i].channel_tags_name=''
                        }
                        if(data[i].store){
                            data[i].store=data[i].store.join(' ')
                        }else{
                            data[i].store=''
                        }
                    }
                }
                this.tabData=data
                this.total=res.meta.pagination.total
                this.tabLoading=false
            }).catch((err=>{
                this.tabLoading=false
                this.$Message.error(error.response.data.message);
            })) 
        },
        changePage(val){
            this.listQuery.page=val
            this.getList()
        },
        changeLimit(val){
            this.listQuery.limit=val
            this.getList()
        },
        changeDepartment(val){
            this.apiOpenStore(val)
        },
        // 清空筛选
        emptyFilter(){
            this.listQuery.page=1
            this.listQuery.department_id=''
            this.listQuery.store_id=''
            this.listQuery.status=''
            this.listQuery.name=''
            this.getList()
        },
        // 查询
        searchList(){
            this.listQuery.page=1
            this.getList()
        },
        // 添加，编辑渠道
        addChannel(id){
            console.log(id)
            if(id!=='isAdd'){
                this.isTitle='修改渠道'
                this.isEditorChannelId=id
                this.apiChannelDetails(id)
            }else{
                this.isTitle='添加渠道'
                this.isEditorChannelId=''
                this.addChannelForm.name=''
                this.addChannelForm.department_id=''
                this.addChannelForm.status=''
                this.addChannelForm.tag_id=[]
                this.addChannelForm.remark=''
                this.openStoreStr=''
                this.showAddChannel=true
            }
        },   
        //下载二维码
        downloadQrCode(){
            this.$refs['editQrCodeForm'].validate((valid) => {
                if (valid) {
                    this.apiQrCodeAddOpenStore();
                    window.open(api.getRecommendQrCode+'?channel_id='+this.editQrCodeForm.channel_id+'&department_id='+this.editQrCodeForm.department_id+'&recommend_token=8541701242fe1c51rwwfs412rew1935e2c6e6c')
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        // 确认
        handleSubmit (name,isTitle) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    switch(name){
                        case 'addChannelForm':
                            if(isTitle=='添加渠道'){
                                this.apiAddChannel()
                            }else if(isTitle=='修改渠道'){
                                this.apiEditorChannel()
                            }
                        break;
                        case 'editQrCodeForm':
                            this.apiQrCodeAddOpenStore();
                        break;
                    }
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        // 取消
        handleReset (name) {
            this.$refs[name].resetFields();
            switch(name){
                case 'addChannelForm':
                    this.showAddChannel=false
                break;
                case 'editQrCodeForm':
                    this.showQrCode=false
                break;
            }
        }
    }
}
</script>
<style>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
.ivu-table-cell {
    white-space: pre-line!important;
}
.ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
.opertionBtn{
    margin-bottom:20px;
    display:flex;
    display: -webkit-flex;
    align-items: center
}
.opertionBtn .item{
    margin-right: 5px
}
.mb-10{
    margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/CrmSetting/channelManagement.vue